/* eslint-disable react/no-array-index-key */
// Items are static and are never reordered or filtered. Unique commentaryId can be used as key when available.

import React from 'react';
import { injectIntl } from 'react-intl';
import { Commentary, TypeLabel } from '../commentary.types';
import { CommentaryListOpenCommentary } from '../list/CommentaryListOpenCommentary';
import { CommentaryListPaperCommentary } from '../list/CommentaryListPaperCommentary';
import { CommentaryListHybridCommentary } from '../list/CommentaryListHybridCommentary';
import {
  ModalScrollableContainer,
  ModalScrollableContent,
  ModalScrollableHeader,
} from '../../components/modal';
import { InjectedIntlProps } from '../../doctrine.types';

type Props = {
  commentaries: Array<Commentary>;
  closeModal: () => void;
  commentaryClicked: Function;
  source: string;
  isOpen: boolean;
} & InjectedIntlProps;

export function RawCommentaryModalContent({
  commentaries,
  closeModal,
  commentaryClicked,
  source,
  isOpen,
  intl,
}: Props) {
  const headerWording = intl.formatMessage(
    { id: 'commentary/modal/CommentaryModalContent.tsx/commentary/1' },
    { count: commentaries.length },
  );

  return (
    <ModalScrollableContainer isOpen={isOpen} onRequestClose={closeModal}>
      <ModalScrollableHeader title={headerWording} onClose={closeModal} />
      <ModalScrollableContent>
        {commentaries.map((commentary: Commentary, index: number) => {
          if (commentary.typeLabel === TypeLabel.HYBRID) {
            return (
              <CommentaryListHybridCommentary
                commentary={commentary}
                key={index}
                source={source}
                onCommentaryClicked={commentaryClicked}
              />
            );
          }
          if (commentary.typeLabel === TypeLabel.PAPER) {
            return (
              <CommentaryListPaperCommentary
                key={index}
                commentary={commentary}
              />
            );
          }
          return (
            <CommentaryListOpenCommentary
              key={index}
              commentary={commentary}
              source={source}
              onCommentaryClicked={commentaryClicked}
            />
          );
        })}
      </ModalScrollableContent>
    </ModalScrollableContainer>
  );
}

export const CommentaryModalContent = injectIntl(RawCommentaryModalContent);
